export const ADD_POSTMESSAGE_LISTENER = "ADD_POSTMESSAGE_LISTENER";

export const addPostMessageListener = (listener) => async (dispatch) => {
  return dispatch({
    type: ADD_POSTMESSAGE_LISTENER,
    payload: listener,
  });
};
